import React, { useState } from "react";
import "./Table.css";
// import your sprite or user image here, e.g.:
// import userImg from "../../../public/assets/teen_patti/users/user.png";
import Loader from "./Loader";
function Table() {
    // Define your 8 seats and their states (empty or occupied by a user)
    const [loading, setLoading] = useState(true);
    const [potAmount] = useState(12540);
    const [chaalAmount] = useState(200);

    const [players] = useState([
        { id: 1, position: "top-left", name: "Player 1", wallet: 2500, seen: false },
        { id: 2, position: "top-right", name: "Player 2", wallet: 8500, seen: false },
        { id: 3, position: "left", name: "Player 3", wallet: 1200, seen: false },
        { id: 4, position: "right", name: "Player 4", wallet: 5600, seen: false },
        { id: 5, position: "bottom-left", name: "Player 5", wallet: 9000, seen: false },
        { id: 6, position: "bottom-right", name: "Player 6", wallet: 4300, seen: false },
        {
            id: 7,
            position: "bottom-sofa-left",
            name: "You",
            wallet: 15000,
            seen: true,
            isMe: true
        },
    ]);

    React.useEffect(() => {

        setTimeout(() => {
            setLoading(false);
        }, 3000);

    }, []);

    if (loading) {
        return <Loader />;
    }
    return (
        <section className="dashboard_layout">
            <div className="container-fluid p-0">

                {/* Game Area Container */}
                <div className="game-table-container">
                    {/* Background Table */}
                    <img
                        src="/assets/teen_patti/table/black.png"
                        alt="Poker Table"
                        className="table-bg"
                    />
                    {/* Center Pot */}
                    <div className="table-center">
                        <div className="pot-box">
                            <span className="pot-label">POT</span>
                            <span className="pot-value">₹{potAmount.toLocaleString()}</span>
                        </div>

                        <div className="chaal-box">
                            <span>CHAAL</span>
                            <strong>₹{chaalAmount}</strong>
                        </div>
                    </div>

                    {/* Render Players */}
                    {players.map((player) => (
                        <React.Fragment key={player.id}>
                            {/* Player */}
                            <div className={`seat-slot ${player.position}`}>
                                <div className="player-character">
                                    <div className="avatar-placeholder">👤</div>
                                    <div className={`player-info ${player.isMe ? "my-info" : ""}`}>
                                        {!player.isMe &&
                                            <div className="player-name">
                                                {player.name}
                                            </div>
                                        }

                                        <div className="player-wallet">
                                            ₹{player.wallet.toLocaleString()}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Cards */}
                            <div className={`player-cards ${player.position}-cards`}>
                                {player.seen ? (
                                    <>
                                        <img src="/assets/teen_patti/cards/14H.png" alt="" />
                                        <img src="/assets/teen_patti/cards/14C.png" alt="" />
                                        <img src="/assets/teen_patti/cards/14S.png" alt="" />
                                    </>
                                ) : (
                                    <>
                                        <img src="/assets/teen_patti/cards/BLANK.png" alt="" />
                                        <img src="/assets/teen_patti/cards/BLANK.png" alt="" />
                                        <img src="/assets/teen_patti/cards/BLANK.png" alt="" />
                                    </>

                                )}
                            </div>
                        </React.Fragment>
                    ))}

                    {/* Action Buttons */}
                    <div className="game-actions">
                        <button className="game-btn seen-btn">
                            <span className="icon">👁</span>
                            <span>Seen</span>
                        </button>

                        <button className="game-btn chaal-btn">
                            <span className="icon">💰</span>
                            <span>Chaal</span>
                        </button>

                        <button className="game-btn chaal2x-btn">
                            <span className="icon">⚡</span>
                            <span>Chaal 2X</span>
                        </button>

                        <button className="game-btn pack-btn">
                            <span className="icon">❌</span>
                            <span>Pack</span>
                        </button>

                        <button className="game-btn sideshow-btn">
                            <span className="icon">🃏</span>
                            <span>Side Show</span>
                        </button>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Table;
